module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/how-much-to-spend-on-a-wedding-gift-b82506989d0279c341ce2293c2bb3474.jpg";